// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e19d7281","455":"6662b865"}[chunkId] + ".chunk.js";
};